import React from "react";

import { ReturnStatusComposite } from "../index";

import { ReturnDetailsCard } from "./ReturnDetailsCard";
import { ReturnStatus } from "../../../types/ReturnStatus";
import { RootReducer } from "../../../redux/reducers";
import useSelector from "../../../utility/useTypedSelector";

const NO_INTEGRATION_PLATFORM = "no-integration";

export const ReturnDetailsCards = (returnStatusComposite: ReturnStatusComposite) => {
  const retailerPlatform = useSelector((store: RootReducer) => store.app.retailerPlatform);
  if (retailerPlatform === NO_INTEGRATION_PLATFORM) {
    return <></>;
  }

  if (!returnStatusComposite?.returnDetails || returnStatusComposite.returnDetails.length == 0 ){
    return (
      <></>
    );
  }


  return (
    <>
      {
        returnStatusComposite.returnDetails.map((returnDetails, index) => {
          const props = {
            index: index,
            ...returnStatusComposite
          }

          return <ReturnDetailsCard {...props} key={`return-details-card-${index}`}/>
        })
      }
    </>
  )
};
